var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.41 37.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-rule:evenodd;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.54,18.77v8.06a.21.21,0,0,0,.21.21h3a.21.21,0,0,0,.21-.21V18.64h2.17a.22.22,0,0,0,.21-.19L22.54,16a.22.22,0,0,0-.21-.23H20V14a.74.74,0,0,1,.74-.74h1.68a.22.22,0,0,0,.21-.21V10.58a.21.21,0,0,0-.21-.21H19.54a3,3,0,0,0-3,3v2.38H15a.21.21,0,0,0-.21.21v2.47a.21.21,0,0,0,.21.21h1.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.25,
    y: 0.25,
    width: 36.91,
    height: 36.91
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb-icon.0999563681469534d48e6e2ba475e1b6.svg";
export { ForwardRef as ReactComponent };